import { concat, curry } from 'ramda';
import { loadingManagementApi } from '../loadingManagementApi';

const generateListTags = curry((type, idProp, list) =>
  list
    ? [...list.map(item => ({ id: item[idProp], type })), { id: 'LIST', type }]
    : [{ id: 'LIST', type }]
);

const getUrl = concat('customer-authorizations/');

const customerAuthorizationsEndpoints = loadingManagementApi.injectEndpoints({
  endpoints: ({ mutation, query }) => ({
    createControlClass: mutation({
      query: ({ body }) => ({
        body,
        keepUnusedDataFor: 10,
        method: 'POST',
        url: getUrl('create-control-class'),
      }),
    }),

    createCustomerAuthorization: mutation({
      invalidatesTags: ['CustomerAuthorizationList'],
      query: ({ body }) => ({
        body,
        keepUnusedDataFor: 10,
        method: 'POST',
        url: getUrl('create-customer-authorization'),
      }),
    }),

    editCustomerAuthorization: mutation({
      invalidatesTags: ['CustomerAuthorizationList'],
      query: ({ body }) => ({
        body,
        keepUnusedDataFor: 10,
        method: 'POST',
        url: getUrl('edit-customer-authorization'),
      }),
    }),

    getCarriers: query({
      providesTags: generateListTags('Carrier', 'carrierId'),
      query: ({ params }) => ({
        keepUnusedDataFor: 10,
        params,
        url: getUrl('get-carriers'),
      }),
    }),

    getCitiesAndZips: query({
      query: ({ params }) => ({
        keepUnusedDataFor: 10,
        params,
        url: getUrl('get-cities-and-zips'),
      }),
    }),

    getClasses: query({
      query: ({ params }) => ({
        keepUnusedDataFor: 10,
        params,
        url: getUrl('get-classes'),
      }),
    }),

    getCustomerAuthorization: query({
      providesTags: ['CustomerAuthorization'],
      query: ({ params }) => ({
        keepUnusedDataFor: 0,
        params,
        url: 'customer-authorizations/edit-customer-authorization',
      }),
    }),

    getDestinations: query({
      query: ({ params }) => ({
        keepUnusedDataFor: 10,
        params,
        url: getUrl('get-destinations'),
      }),
    }),

    getProducts: query({
      providesTags: generateListTags('Product', 'productId'),
      query: ({ params }) => ({
        keepUnusedDataFor: 10,
        params,
        url: getUrl('get-products'),
      }),
    }),

    getStates: query({
      keepUnusedDataFor: 1800,
      query: () => getUrl('get-states'),
    }),

    getTerminals: query({
      providesTags: generateListTags('Terminal', 'terminalId'),
      query: ({ params }) => ({
        keepUnusedDataFor: 10,
        params,
        url: getUrl('get-terminals'),
      }),
    }),

    getViewCustomerAuthorization: query({
      providesTags: ['CustomerAuthorization'],
      query: ({ params }) => ({
        keepUnusedDataFor: 0,
        params,
        url: getUrl('view-customer-authorization'),
      }),
    }),

    verifyControlNumber: query({
      query: ({ params }) => ({
        keepUnusedDataFor: 10,
        params,
        url: getUrl('verify-control-number'),
      }),
    }),

    verifyCustomerId: query({
      query: ({ params }) => ({
        keepUnusedDataFor: 10,
        params,
        url: getUrl('verify-supplier-customer-id'),
      }),
    }),
  }),
});

export const {
  useEditCustomerAuthorizationMutation,
  useCreateCustomerAuthorizationMutation,
  useGetCarriersQuery,
  useGetCitiesAndZipsQuery,
  useGetClassesQuery,
  useGetCustomerAuthorizationQuery,
  useGetDestinationsQuery,
  useGetProductsQuery,
  useGetStatesQuery,
  useGetTerminalsQuery,
  useGetViewCustomerAuthorizationQuery,
  useVerifyControlNumberQuery,
  useVerifyCustomerIdQuery,
  useCreateControlClassMutation,
} = customerAuthorizationsEndpoints;
